import { PivotAggregationEnum, PivotFieldTypeEnum } from '@ztechapps/common.contract'

/** The aggregations a field allows — every one for a number field, only the count kinds otherwise. */
export const listPivotFieldAggregations = (type: PivotFieldTypeEnum): PivotAggregationEnum[] =>
  type === PivotFieldTypeEnum.Number
    ? Object.values(PivotAggregationEnum)
    : [PivotAggregationEnum.Count, PivotAggregationEnum.DistinctCount]
